// import Cookies from 'js-cookie'

const ACCOUNT = 'account'

export function getAccount() {
  return sessionStorage.getItem(ACCOUNT)
}

export function setAccount(token) {
  return sessionStorage.setItem(ACCOUNT, token)
}

export function removeAccount() {
  return sessionStorage.removeItem(ACCOUNT)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js